// extracted by mini-css-extract-plugin
var _1 = "AttachmentAddZone_dropzone__H5wht";
var _2 = "AttachmentAddZone_dropzoneText__C6Q4O";
var _3 = "AttachmentAddZone_wrapper__dnijA";
export { _1 as "dropzone", _2 as "dropzoneText", _3 as "wrapper" }
